import { associatePerformanceService, associateScorecardService } from 'config/api';
import actionTypes from './actionTypes';
import { adjustPerformanceParams } from '../utils';

export const getMetrics = (associatePin, options = {}) => async (dispatch) => {
  dispatch({
    type: actionTypes.PERF_DATA_LOADING,
  });

  const params = adjustPerformanceParams(options);

  try {
    const response = await associatePerformanceService.post(`v3/data/${associatePin}/metrics`, params);
    dispatch({ type: actionTypes.PERFORMANCE_DATA_SUCCESS, payload: response.data });
  } catch (error) {
    dispatch({ type: actionTypes.PERF_DATA_ERROR, payload: error });
  }
};

export const clearMetricsData = () => ({
  type: actionTypes.PERFORMANCE_DATA_RESET,
});

export const triggerPerformanceService = (queryParam) => async (dispatch) => {
  dispatch({
    type: actionTypes.PERF_DATA_LOADING,
  });

  try {
    const res = await associatePerformanceService.get(queryParam);
    dispatch({ type: actionTypes.SALES_DATA_SUCCESS, payload: res.data });
  } catch (error) {
    dispatch({ type: actionTypes.PERF_DATA_ERROR, payload: error });
  }
};

export const getTodaysSalesForAssociate = (associatePin, version = 'v2', managerStoreId = '') => async (dispatch) => {
  dispatch({
    type: actionTypes.TODAYS_SALES_LOADING,
  });
  const storeId = version === 'v3' && managerStoreId ? `?storeId=${parseInt(managerStoreId, 10)}` : '';
  const storeNumber = managerStoreId && { storeId: managerStoreId };
  try {
    const url = `/${version}/data/${associatePin}/sales${storeId}`;
    const res = await associatePerformanceService.get(url);
    dispatch({ type: actionTypes.TODAYS_SALES_SUCCESS, payload: { data: res.data, ...storeNumber } });
  } catch (error) {
    dispatch({ type: actionTypes.TODAYS_SALES_ERROR, payload: error });
  }
};

export const getSalesForManager = (managerSalesQuery, storeId, isTreeModeEnabled) => async (dispatch) => {
  dispatch({
    type: actionTypes.MANAGER_SALES_LOADING,
  });

  try {
    const { type } = managerSalesQuery;
    const associateSales = type === 'ASSOCIATES' || type === 'MY_TEAM' ? '/associates' : '';
    const query = storeId ? `?storeId=${parseInt(storeId, 10)}` : '';

    const {
      data: { items, count },
    } = await associatePerformanceService.post(`/v1/manager/sales/metrics${associateSales}${query}`, managerSalesQuery);

    const payload = {
      dataType: managerSalesQuery.type,
      items,
      count,
    };

    if (isTreeModeEnabled) {
      dispatch({ type: actionTypes.MANAGER_SALES_TREE_SUCCESS, payload });
    } else {
      dispatch({ type: actionTypes.MANAGER_SALES_SUCCESS, payload });
    }
  } catch (error) {
    dispatch({ type: actionTypes.MANAGER_SALES_ERROR, payload: error });
  }
};

export const getSalesTreeForManager = (requestParams, storeId) => async (dispatch) => {
  dispatch({
    type: actionTypes.MANAGER_SALES_TREE_LOADING,
  });

  try {
    const query = storeId ? `?storeId=${parseInt(storeId, 10)}` : '';
    const { divisionId, groupId } = requestParams;
    const {
      data: { items, count },
    } = await associatePerformanceService.post(`/v1/manager/sales/divisionMetrics/${query}`, requestParams);

    dispatch({
      type: actionTypes.MANAGER_SALES_TREE_SUCCESS,
      payload: { items, count, divisionId, groupId },
    });
  } catch (error) {
    dispatch({ type: actionTypes.MANAGER_SALES_TREE_ERROR, payload: error });
  }
};

export const saveManagerSalesTree = ({ pageId, processedNodeIds, expandedNodesMap }) => ({
  type: actionTypes.MANAGER_SALES_TREE_SAVE_STATE,
  payload: { pageId, processedNodeIds, expandedNodesMap },
});

export const clearManagerSalesTreeCache = () => ({
  type: actionTypes.MANAGER_SALES_TREE_CLEAR_CACHE,
});

export const managerSalesTreeRestore = (pageId) => ({
  type: actionTypes.MANAGER_SALES_TREE_RESTORE,
  payload: { pageId },
});

export const clearSalesTreeForManager = () => ({
  type: actionTypes.MANAGER_SALES_TREE_CLEAR,
});

export const clearManagerSales = () => ({
  type: actionTypes.MANAGER_SALES_CLEAR,
});

export const getManagerSalesDetails = (requestParams, storeId) => async (dispatch) => {
  const requestQuery = storeId ? `?storeId=${parseInt(storeId, 10)}` : '';

  dispatch({ type: actionTypes.MANAGER_SALES_DETAILS_LOADING });

  try {
    const { data } = await associatePerformanceService.post(`/v1/manager/sales/details${requestQuery}`, requestParams);
    dispatch({ type: actionTypes.MANAGER_SALES_DETAILS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: actionTypes.MANAGER_SALES_DETAILS_ERROR });
  }
};

export const getTodaysSalesForAssociateV3 = (associatePin, storeNumber) =>
  getTodaysSalesForAssociate(associatePin, 'v3', storeNumber);

export const getAssociateScorecard = (associatePin, filterType) => async (dispatch) => {
  dispatch({ type: actionTypes.ASSOCIATE_MY_SCORECARD_LOADING });

  try {
    const options = { params: { timePeriod: filterType } };
    const { data } = await associateScorecardService.get(`/v1/scorecard/${associatePin}/sales`, options);
    dispatch({ type: actionTypes.ASSOCIATE_MY_SCORECARD_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: actionTypes.ASSOCIATE_MY_SCORECARD_ERROR });
  }
};

export const getEngagements = (associatePin, timePeriod) => async (dispatch) => {
  dispatch({
    type: actionTypes.ASSOCIATE_ENGAGEMENTS_LOADING,
  });

  try {
    const options = { params: { timePeriod } };
    const { data } = await associateScorecardService.get(`/v1/scorecard/${associatePin}/outreach`, options);
    dispatch({
      type: actionTypes.ASSOCIATE_ENGAGEMENTS_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: actionTypes.ASSOCIATE_ENGAGEMENTS_ERROR,
      payload: error,
    });
  }
};
